import { Link } from 'react-router-dom';
import { useInView } from '@/hooks/useInView';

export default function AboutSection() {
  const [ref, isInView] = useInView();

  return (
    <section ref={ref} className="relative bg-background-50 py-16 md:py-20">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className={`flex flex-col lg:flex-row items-center gap-12 lg:gap-20 transition-all duration-700 ease-out ${isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="w-full lg:w-1/2">
            <div className="relative rounded-[32px] overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Organized%20creative%20studio%20workspace%20with%20large%20monitor%20displaying%20colorful%20spreadsheet%20dashboard%2C%20moodboard%20wall%20with%20fashion%20product%20photos%20and%20fabric%20swatches%20pinned%20up%2C%20natural%20daylight%20pouring%20through%20industrial%20windows%2C%20warm%20wooden%20desk%20surface%20with%20notebook%20and%20coffee%2C%20inspiring%20creative%20atmosphere%2C%20editorial%20interior%20photography&width=800&height=600&seq=about-img-v2&orientation=landscape"
                alt="Organized mulebuy spreadsheet creative studio workspace with fashion inspiration moodboard"
                className="w-full aspect-[4/3] object-cover rounded-[32px]"
              />
            </div>
          </div>

          <div className="w-full lg:w-1/2 flex flex-col items-start">
            <span className="inline-flex items-center px-3 py-1 rounded-lg bg-accent-100 text-accent-800 text-xs font-semibold mb-5 uppercase tracking-wide">
              Verified Guide
            </span>

            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-[1.15] mb-6">
              Why Use Mulebuy
              <br />
              Spreadsheet Daily
            </h2>

            <p className="text-base text-foreground-600 leading-relaxed mb-6 max-w-lg">
              The <strong>mulebuy spreadsheet</strong> system gives you instant access to verified product listings from trusted China agent platforms. Instead of spending hours searching manually, you get curated, community-tested finds delivered through organized spreadsheets.
            </p>

            <div className="space-y-4 mb-8">
              {[
                { icon: 'ri-checkbox-circle-line', text: 'Verified product listings updated daily' },
                { icon: 'ri-flashlight-line', text: 'Faster shopping through trusted agent connections' },
                { icon: 'ri-money-dollar-circle-line', text: 'Lower cost than mainstream retail platforms' },
                { icon: 'ri-group-line', text: 'Community-tested product finds and reviews' },
                { icon: 'ri-refresh-line', text: 'Daily spreadsheet data refreshes keep listings accurate' },
              ].map((item, idx) => (
                <div key={idx} className="flex items-start gap-3">
                  <span className="w-5 h-5 flex items-center justify-center mt-0.5">
                    <i className={`${item.icon} text-accent-600 text-sm`}></i>
                  </span>
                  <span className="text-sm text-foreground-600">{item.text}</span>
                </div>
              ))}
            </div>

            <Link
              to="/mulebuy-spreadsheet-guide"
              className="inline-flex items-center gap-3 px-7 py-3.5 rounded-xl bg-background-100 text-foreground-900 text-sm font-semibold whitespace-nowrap hover:bg-accent-100 transition-colors cursor-pointer group"
            >
              Explore the Full Hub
              <span className="w-6 h-6 flex items-center justify-center">
                <i className="ri-arrow-right-up-line text-sm group-hover:text-accent-600 transition-colors"></i>
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}